import React from 'react';
import PropTypes from 'prop-types';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import CommunityMapCard from '../../components/CommunityMapCard';
import ContactModal from '../../components/ContactModal';
import { colors, typography } from '../../styles';

const styles = css`
.IndexMap_section {
  background-color: ${colors.color4};
  position: absolute;
  left: -999999px;
  margin: 0 0 140px 0;
  .IndexMap_heading {
    text-align: center;
    text-transform: uppercase;
    font-family: ${typography.Serif};
    font-size: 42px;
    margin: 0;
    padding: 20px;
  }
  .Communities_communitiesResults {
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      display: flex;
    }
  }
  .IndexMap_cta {
    background-color: ${colors.color2};
    position: absolute;
    bottom: -70px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: fit-content;
    z-index: 1;
    text-transform: uppercase;
    font-weight: bold;
    cursor: pointer;
    .IndexMap_cta-left {
      text-align: right;
      font-size: 32px;
      width: 300px;
      display:inline-block;
      border-right: 1px solid #fff;
      margin: 20px;
      padding-right: 15px;
    }
    .IndexMap_cta-right {
      text-align: left;
      font-size: 22px;
      width: 350px;
      display: inline-block;
      margin-right: 20px;
      vertical-align: sub;
      .IndexMap_cta-rightSpan {
        color: #fff;
        display: block;
        font-size: 25px;
        letter-spacing: 2px;
      }
    }
  }
  @media(min-width: 992px) {
    position: relative;
    left: unset;
  }
}
`;

const communityMap = css`
  background-color: ${colors.color3};
  position: relative;
  height: 600px;
  width: 100%;
  z-index: 0;

  @media (min-width: 992px) {
    width: auto;
    flex-grow: 1;
  }
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
`;

function IndexMap({ activeMapPin, communities, builder }) {
  return (
    <div className={styles}>
      <div className="IndexMap_section">
        <h3 className="IndexMap_heading">Find your Community</h3>
        <div className="Communities_communitiesResults">
          <CoreMap
            className={communityMap}
            pin={{
              iconUrl: '/images/icon-map-pin-woodbridge.svg',
              iconSize: [32, 46],
              iconAnchor: [16, 46],
              popupAnchor: [0, -41],
            }}
            activePin={activeMapPin}
            markers={communities}
            popup={({ marker: community }) => (
              <CommunityMapCard community={community} />
            )}
            boundaryPadding={8}
          />
        </div>
        <ContactModal builder={builder}>
          <div className="IndexMap_cta">
            <div className="IndexMap_cta-left">New Units Selling Quickly</div>
            <div className="IndexMap_cta-right">New Communities Coming Soon!
              <span className="IndexMap_cta-rightSpan">Contact Us Today!</span>
            </div>
          </div>
        </ContactModal>
      </div>
    </div>
  );
}

IndexMap.propTypes = {
  builder: PropTypes.object.isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeMapPin: PropTypes.string,
};

IndexMap.defaultProps = {
  activeMapPin: undefined,
  sort: {},
};

export default withData({
  communities: true,
})(IndexMap);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/IndexMap.js